const zh = {
  10000001: 'SuperEx二周年庆',
  10000002: '签到领取丰厚奖励！',
  10000003: '根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高10,000USDT獎金池',
  10000004: 'SuperEx 兩週年',
  10000005: '合約慶典賽贏取20,000USDT',
  10000006: `交易量排名赛，解锁最高 <span style="color: #ffc72b;">10,000</span> USDT 奖金池`,
  10000007: '合約冠軍賽',
  10000008: '贏取20,000USDT獎池！',
  10000009: '',
  10000010: '',
  10000011: '',
  10000012: '',
  10000013: '',
  10000014: '',
  10000015: '',
  10000016: '',
  10000017: '',
  10000018: '',
  10000019: '',
  10000020: '',
  10000021: '',
  10000022: '',
  10000023: '',
  10000024: '',
  10000025: '',
  10000026: '',
  10000027: '',
  10000028: '',
  10000029: '',
  10000030: '',
}
export default zh



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/zh.js